export default "__VITE_ASSET__82e9fb43__"